import React from "react";
import vs from "../images/x1.png";
import vs2 from "../images/x2.png";
import vs3 from "../images/x3.png";
import vs4 from "../images/x4.png";
function About() {
  return (
    <div>
      <section className="about" id="faq">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <h5>MEME about $SOLTY!</h5>
            </div>
          </div>
          <div className="row caqz">
            <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0">
              <div className="bPxa" data-aos="fade-up" data-aos-duration="500">
                <div className="worldx">
                  <div className="bkss">
                    <img src={vs} />
                  </div>
                  <p>
                    Backed by the irresistible charm of the Lucky Red Panda,
                    $SOLTY presale is more than just a cryptocurrency - it's a
                    movement that's about to take the world by storm.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0">
              <div className="bPxa" data-aos="fade-up" data-aos-duration="1000">
                <div className="worldx">
                  <div className="bkss">
                    <img src={vs2} />
                  </div>
                  <p>
                    $SOLTY is not just another meme coin - it's a revolution.
                    Inspired by the stories of everyday people who have overcome
                    their humble beginnings to achieve greatness, $SOLTY is a
                    symbol of the power of the people.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0">
              <div className="bPxa" data-aos="fade-up" data-aos-duration="1500">
                <div className="worldx">
                  <div className="bkss">
                    <img src={vs3} />
                  </div>
                  <p>
                    By buying presale $SOLTY, you're not just buying a meme -
                    you're becoming a part of a community that's dedicated to
                    transforming the financial landscape. Together, we'll rise
                    from the rags and soar to the riches, one meme-fueled
                    transaction at a time.!
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0">
              <div className="bPxa" data-aos="fade-up" data-aos-duration="2000">
                <div className="worldx">
                  <div className="bkss">
                    <img src={vs4} />
                  </div>
                  <p>
                    With his catchy name and adorable mascot meme skills, $SOLTY
                    presale is the must-have token for anyone who wants to ride
                    the wave of the Meme Coin Revolution and bankless evolution.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
